// Deep-link tab names -> index for ReconciliationHub.
// Pure constants — kept import-light so they are unit-testable (same pattern as
// plDatePresets.js).
//
// This used to be a single hardcoded expression inside the component
// (`?tab=transactions ? 6 : 0`), and the comment beside it recorded that the
// literal had ALREADY gone stale once: "Index 6 after the 2026-07-10 tab
// rationalization (was 9 in the 13-tab layout)". A renumbering silently sends
// every saved link to the wrong screen with no error, so the mapping is named
// here and asserted by reconciliationTabs.test.js.
//
// `transactions` is load-bearing: Balance Sheet and Cash Flow already deep-link
// through ?tab=transactions. It must keep resolving to All Transactions.
//
// Order MUST match the <Tab> elements rendered in ReconciliationHub.js.
export const TAB_INDEX = {
  'journal-entries': 0,
  'chart-of-accounts': 1,
  'ai-classifications': 2,
  'ap-reports': 3,
  'fuzzy-match': 4,
  backlog: 5,
  transactions: 6,
  counterparties: 7,
  'warehouse-ap': 8,
  'ap-match-review': 9,
};

// The tab labels as rendered, in strip order. Kept beside TAB_INDEX so the test
// can assert the two agree without importing the component (which pulls in axios
// and MUI and is not unit-testable).
export const TAB_LABELS = [
  'Journal Entries',
  'Chart of Accounts',
  'AI Classifications',
  'AP Reports',
  'Fuzzy Match Review',
  'Backlog Analysis',
  'All Transactions',
  'Counterparties',
  'Warehouse AP',
  'AP Match Review',
];

// Resolve a ?tab= value to a tab index. Unknown, absent, or inherited-prototype
// names ("constructor", "toString") fall back to the first tab rather than
// resolving to a function.
export function resolveTabIndex(name) {
  return Object.prototype.hasOwnProperty.call(TAB_INDEX, name) ? TAB_INDEX[name] : 0;
}
